"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function default_1() {
    (0, react_1.useLayoutEffect)(() => {
        const navHeader = document.getElementById('nav_header');
        navHeader === null || navHeader === void 0 ? void 0 : navHeader.classList.add('hide_below_768');
        return () => navHeader === null || navHeader === void 0 ? void 0 : navHeader.classList.remove('hide_below_768');
    }, []);
}
exports.default = default_1;
